const ruDate = new Intl.DateTimeFormat('ru-RU', {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
});

const ruDateTime = new Intl.DateTimeFormat('ru-RU', {
  day: '2-digit',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

const rubFormatter = new Intl.NumberFormat('ru-RU', {
  style: 'currency',
  currency: 'RUB',
  maximumFractionDigits: 0,
});

function parseDisplayDate(value) {
  if (!value) return null;

  const text = String(value).trim();
  const dateOnly = text.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (dateOnly) {
    return new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]), 12, 0, 0);
  }

  const dbDateTime = text.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{1,2}):(\d{2})(?::(\d{2}))?/);
  if (dbDateTime) {
    return new Date(
      Number(dbDateTime[1]),
      Number(dbDateTime[2]) - 1,
      Number(dbDateTime[3]),
      Number(dbDateTime[4]),
      Number(dbDateTime[5]),
      Number(dbDateTime[6] || 0)
    );
  }

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatDate(value) {
  if (!value) return '—';
  const date = parseDisplayDate(value);
  return date ? ruDate.format(date) : value;
}

export function formatDateTime(value) {
  if (!value) return '—';
  const date = parseDisplayDate(value);
  return date ? ruDateTime.format(date) : value;
}

export function formatTime(value) {
  if (!value) return '—';
  return String(value).slice(0, 5);
}

export function formatPrice(value) {
  if (value === null || value === undefined || value === '') return '—';
  const number = Number(value);
  if (Number.isNaN(number)) return String(value);
  return rubFormatter.format(number);
}

export function pluralize(count, one, few, many) {
  const mod10 = count % 10;
  const mod100 = count % 100;
  if (mod10 === 1 && mod100 !== 11) return one;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few;
  return many;
}

export function statusMeta(status) {
  const map = {
    created: { label: 'Создана', tone: 'pending' },
    confirmed: { label: 'Подтверждена', tone: 'success' },
    accepted: { label: 'Принята', tone: 'success' },
    in_progress: { label: 'В процессе', tone: 'warning' },
    completed: { label: 'Завершена', tone: 'neutral' },
    cancelled: { label: 'Отменена', tone: 'danger' },
    no_show: { label: 'Не пришёл', tone: 'danger' },
    rejected: { label: 'Отклонена', tone: 'danger' },

    'создана': { label: 'Создана', tone: 'pending' },
    'подтверждена': { label: 'Подтверждена', tone: 'success' },
    'принято': { label: 'Принята', tone: 'success' },
    'принята': { label: 'Принята', tone: 'success' },
    'в процессе': { label: 'В процессе', tone: 'warning' },
    'завершено': { label: 'Завершена', tone: 'neutral' },
    'завершена': { label: 'Завершена', tone: 'neutral' },
    'отменено': { label: 'Отменена', tone: 'danger' },
    'отменена': { label: 'Отменена', tone: 'danger' },
    'не пришёл': { label: 'Не пришёл', tone: 'danger' },
    'не пришел': { label: 'Не пришёл', tone: 'danger' },
    'отклонено': { label: 'Отклонена', tone: 'danger' },
    'отклонена': { label: 'Отклонена', tone: 'danger' },
  };

  return map[String(status || '').trim().toLowerCase()] || {
    label: status || '—',
    tone: 'neutral',
  };
}

export function paymentMeta(status) {
  const map = {
    not_paid: 'Не оплачено',
    paid: 'Оплачено',
    partial: 'Частично оплачено',
    refunded: 'Возврат',
  };

  return map[String(status || '').toLowerCase()] || '—';
}

export function userDisplayName(user) {
  return user?.full_name || user?.FIO || user?.email || 'Игрок';
}

export function initialsFromName(name) {
  const cleaned = String(name || '').trim();
  if (!cleaned) return 'BH';
  return cleaned
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join('');
}
